<div *ngIf="emailData && !emailData.hasError"
    [ngSwitch]="currentStatus"
    [hidden]="noResult"
    class="campaign-email"
    [ngClass]="containerCss">
    <ng-container *ngSwitchCase="EmailCaptureStatus.UNSUBSCRIBED_GUEST">
        <div [ngClass]="emailData.media?.type" [ngSwitch]="emailData.media?.type">
            <ng-container *ngSwitchCase="'lottie'">
                <ng-container
                    *ngTemplateOutlet="lottie; context: {$implicit: emailData}">
                </ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'image'">
                <ng-container
                    *ngTemplateOutlet="picture; context: {$implicit: emailData}">
                </ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'logo'">
                <ng-container
                    *ngTemplateOutlet="logo; context: {$implicit: emailData}">
                </ng-container>
            </ng-container>
            <ng-container *ngSwitchDefault>
                <ng-container
                    *ngTemplateOutlet="signup; context: {$implicit: emailData}">
                </ng-container>
            </ng-container>
        </div>
    </ng-container>
    <ng-container *ngSwitchCase="EmailCaptureStatus.SUBSCRIBED_GUEST">
        <div class="email-content email-text email-message"
            [innerHTML]="emailData.successText | safeHtml">
        </div>
    </ng-container>
</div>

<!-- Email Capture with Lottie Animation -->
<ng-template #lottie let-data>
    @defer {
        <finder-lottie *ngIf="data.media?.lottie1"
            [data]="data.media.lottie1">
        </finder-lottie>
    }
    <ng-container
        *ngTemplateOutlet="signup; context: {$implicit: data}">
    </ng-container>
</ng-template>

<!-- Email Capture with Image component -->
<ng-template #picture let-data>
    <finder-picture *ngIf="data.media?.media1"
        [picture]="data.media.media1"
        [ngClass]="data.imagePlacement"
        class="email-image">
    </finder-picture>
    <ng-container
        *ngTemplateOutlet="signup; context: {$implicit: data}">
    </ng-container>
</ng-template>

<!-- Email Capture with Logo in between -->
<ng-template #logo let-data>
    <span class="email-text"
        [innerHTML]="data.signupText[0] | safeHtml">
    </span>
    <finder-picture *ngIf="data.media?.media1"
        [picture]="data.media.media1"
        [ngClass]="data.imagePlacement"
        class="email-image">
    </finder-picture>
    <span class="email-text"
        [innerHTML]="data.signupText[1] | safeHtml">
    </span>
    <finder-one-id-ui
        [captureStyle]="captureStyle"
        [data]="data"
        (oidResult)="handleResult($event)">
    </finder-one-id-ui>
</ng-template>

<!-- Default Template: Signup text and button -->
<ng-template #signup let-data>
    <div class="email-content modal">
        <span class="email-text has-button"
            [innerHTML]="data.signupText | safeHtml">
        </span>
        <finder-one-id-ui
            [captureStyle]="captureStyle"
            [data]="data"
            (oidResult)="handleResult($event)">
        </finder-one-id-ui>
    </div>
</ng-template>
